import moment from 'moment-timezone';

export const convertUTCDateToLocalDate = (date) => {
    // Verificar si es un objeto Date o una cadena y convertir
    const momentDate = (date instanceof Date) ? moment(date) : moment.utc(date);

    if (!momentDate.isValid()) {
        console.error("Fecha no válida:", date);
        return null;
    }

    return momentDate.local().toDate();
};


export const traducir = (name) =>{
    if (name=="Pediatrics")
        return "Pediatría"
    else if (name=="Pediatric surgery")
        return "Cirugía pediátrica"
    else if (name=="Rheumatology")
        return "Reumatología"
    else if (name=="Toxicology")
        return "Toxicología"
    else if (name=="Urology")
        return "Urología"
    else if (name=="Cardiology")
        return "Cardiología"
    else if (name=="Dermatology")
        return "Dermatología"
    else if (name=="Nutrition")
        return "Nutrición"
    else if (name=="Embryology")
        return "Embriología"
    else if (name=="Emergency medicine")
        return "Medicina de emergencias"
    else if (name=="Endocrinology")
        return "Endocrinología"
    else if (name=="Family Medicine")
        return "Medicina Familiar"
    else if (name=="Forensic Medicine")
        return "Medicina Forense"
    else if (name=="Gastroenterology")
        return "Gastroenterología"
    else if (name=="General surgery")
        return "Cirugía general"
    else if (name=="Anatomy")
        return "Anatomía"
    else if (name=="Genetics")
        return "Genética"
    else if (name=="Geriatrics")
        return "Geriatría"
    else if (name=="Gynecology")
        return "Ginecología"
    else if (name=="Hematology")
        return "Hematología"
    else if (name=="Hepatology")
        return "Hepatología"
    else if (name=="Histology")
        return "Histología"
    else if (name=="Immunology")
        return "Inmunología"
    else if (name=="Infectious disease")
        return "Enfermedades infecciosas"
    else if (name=="Andrology")
        return "Andrología"
    else if (name=="Nephrology")
        return "Nefrología"
    else if (name=="Neurology")
        return "Neurología"
    else if (name=="Neurosurgery")
        return "Neurocirugía"
    else if (name=="Nursing")
        return "Enfermería"
    else if (name=="Obstetrics and gynecology")
        return "Ginecología y Obstetricia"
    else if (name=="Oncology")
        return "Oncología"
    else if (name=="Ophthalmology")
        return "Oftalmología"
    else if (name=="Orthopedic surgery")
        return "Cirugía ortopédica"
    else if (name=="Otolaryngology - ENT")
        return "Otorrinolaringología - ENT"
    else if (name=="Palliative care")
        return "Cuidados paliativos"
    else if (name=="Alternative Medicine")
        return "Medicina Alternativa"
    else if (name=="Pathology")
        return "Patología"
    else if (name=="Pharmacology")
        return "Farmacología"
    else if (name=="Plastic surgery")
        return "Cirugía plástica"
    else if (name=="Proctology")
        return "Proctología"
    else if (name=="Psychiatry")
        return "Psiquiatría"
    else if (name=="Pulmonology")
        return "Neumología"
    else if (name=="Radiology")
        return "Radiología"
    else if (name=="Anesthesiology")
        return "Anestesiología"
    else if (name=="Stomatology")
        return "Estomatología"
    else if (name=="Surgical oncology")
        return "Oncología quirúrgica"
    else if (name=="Thoracic surgery")
        return "Cirugía torácica"
    else if (name=="Transplant surgery")
        return "Cirugía de trasplante"
    else if (name=="Trauma surgery")
        return "Traumatólogo"
    else if (name=="Urgent Care Medicine")
        return "Medicina de urgencia"
    else if (name=="Vascular surgery")
        return "Cirugía vascular"
    else if (name=="Biochemistry")
        return "Bioquímica"
    else if (name=="General Practitioner")
        return "Médico clínico"
    else if (name=="Internal Medicine")
        return "Medicina Interna"
    else if (name=="Speech Therapy / Phonoaudiology")
        return "Terapia del habla / Fonoaudiología"
    else if (name=="Psychology")
        return "Psicología"
    else if (name=="Pain Medicine")
        return "Medicina paliativa"
    else if (name=="Integrative Medicine")
        return "Medicina Integral"
    else if (name=="Primary Care")
        return "Atención Primaria"
    else if (name=="Neonatology")
        return "Neonatología"
    else if (name=="Cardiothoracic Surgery")
        return "Cirugía Cardiotorácica"
    else if (name=="Obstetrics")
        return "Obstetricia"
    else if (name=="Family Planning (Primary Care)")
        return "Planificación Familiar (Atención Primaria)"
    else if (name=="Social Services")
        return "Servicios Sociales"
    else if (name=="Oral Medicine (Primary Care)")
        return "Medicina Oral (Atención Primaria)"
    else if (name=="Child Health (Primary Care)")
        return "Salud Infantil (Atención Primaria)"
    else if (name=="Woman Health (Primary Care)")
        return "Salud de la Mujer (Atención Primaria)"
    else if (name=="Cardiovascular surgery")
        return "Cirugía cardiovascular"
    else if (name=="Clinical laboratory sciences")
        return "Ciencias clínicas de laboratorio"
    else
        return "Medicina General"
}

// Función reutilizable para abrir WhatsApp
export const openWhatsApp = (phoneNumber, event = null) => {
    // Validar que hay un teléfono
    if (!phoneNumber) {
        alert('El paciente no tiene número de teléfono registrado');
        return;
    }
    
    // Si se presiona Ctrl+Click, resetear preferencias
    if (event && event.ctrlKey) {
        localStorage.removeItem('whatsapp_preference');
        alert('✅ Preferencias de WhatsApp reseteadas');
        return;
    }
    
    // Limpiar y formatear el número de teléfono
    let cleanPhoneNumber = phoneNumber.replace(/[^\d]/g, '');
    
    // Formatear para Argentina si no tiene código de país
    if (!cleanPhoneNumber.startsWith('54')) {
        cleanPhoneNumber = '549' + cleanPhoneNumber;
    }
    
    // Para desktop (protocolo whatsapp://)
    const phoneNumberDesktop = cleanPhoneNumber;
    
    // Para web (necesita el +)
    const phoneNumberWeb = '+' + cleanPhoneNumber;
    
    // Manejar la elección
    handleWhatsAppChoice(phoneNumberDesktop, phoneNumberWeb);
};

const handleWhatsAppChoice = (phoneNumberDesktop, phoneNumberWeb) => {
    // Verificar si hay una preferencia guardada
    const savedPreference = localStorage.getItem('whatsapp_preference');
    
    if (savedPreference) {
        // Usar preferencia guardada
        if (savedPreference === 'desktop') {
            window.location.href = `whatsapp://send?phone=${phoneNumberDesktop}`;
        } else {
            window.open(`https://web.whatsapp.com/send?phone=${phoneNumberWeb}`, '_blank');
        }
    } else {
        // Mostrar diálogo con checkbox
        showWhatsAppDialog(phoneNumberDesktop, phoneNumberWeb);
    }
};

const showWhatsAppDialog = (phoneNumberDesktop, phoneNumberWeb) => {
    // Crear un diálogo HTML personalizado
    const dialog = document.createElement('div');
    dialog.innerHTML = `
        <div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 10000; display: flex; align-items: center; justify-content: center;">
            <div style="background: white; padding: 20px; border-radius: 8px; max-width: 400px; text-align: center; box-shadow: 0 4px 12px rgba(0,0,0,0.3);">
                <h3 style="margin-top: 0; color: #333;">¿Cómo quiere abrir WhatsApp?</h3>
                <div style="margin: 20px 0; text-align: left;">
                    <label style="display: block; margin: 10px 0; cursor: pointer;">
                        <input type="radio" name="whatsapp_option" value="desktop" style="margin-right: 8px;">
                        <span style="color: #25d366;">✅ WhatsApp Desktop</span>
                    </label>
                    <label style="display: block; margin: 10px 0; cursor: pointer;">
                        <input type="radio" name="whatsapp_option" value="web" style="margin-right: 8px;">
                        <span style="color: #128c7e;">🌐 WhatsApp Web</span>
                    </label>
                </div>
                <div style="margin: 15px 0; text-align: left;">
                    <label style="cursor: pointer;">
                        <input type="checkbox" id="remember_choice" style="margin-right: 8px;">
                        <span style="font-size: 14px;">💾 Recordar mi decisión</span>
                    </label>
                </div>
                <div style="margin-top: 20px;">
                    <button id="whatsapp_ok" style="background: #25d366; color: white; border: none; padding: 10px 20px; border-radius: 5px; margin-right: 10px; cursor: pointer;">Aceptar</button>
                    <button id="whatsapp_cancel" style="background: #ccc; color: #333; border: none; padding: 10px 20px; border-radius: 5px; cursor: pointer;">Cancelar</button>
                </div>
            </div>
        </div>
    `;
    
    document.body.appendChild(dialog);
    
    // Manejar eventos
    const okButton = dialog.querySelector('#whatsapp_ok');
    const cancelButton = dialog.querySelector('#whatsapp_cancel');
    const rememberCheckbox = dialog.querySelector('#remember_choice');
    
    okButton.addEventListener('click', () => {
        const selectedOption = dialog.querySelector('input[name="whatsapp_option"]:checked');
        if (!selectedOption) {
            alert('Por favor seleccione una opción');
            return;
        }
        
        const remember = rememberCheckbox.checked;
        const option = selectedOption.value;
        
        if (remember) {
            localStorage.setItem('whatsapp_preference', option);
        }
        
        if (option === 'desktop') {
            window.location.href = `whatsapp://send?phone=${phoneNumberDesktop}`;
        } else {
            window.open(`https://web.whatsapp.com/send?phone=${phoneNumberWeb}`, '_blank');
        }
        
        document.body.removeChild(dialog);
    });
    
    cancelButton.addEventListener('click', () => {
        document.body.removeChild(dialog);
    });
};